<template>
  <button class="panel-size-btn" :class="{'panel-size-btn--expanded': isExpandedView}">
    <svg-icon :icon="arrow" :width="7" :height="11"></svg-icon>
    <span>{{ buttonText }}</span>
  </button>
</template>

<script>
  import SvgIcon from '@/components/common/svgIcon'
  import arrow from '@/assets/svg/arrow.svg'

  export default {
    components: {
      SvgIcon
    },
    props: {
      isExpandedView: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        arrow
      }
    },
    computed: {
      buttonText () {
        return this.isExpandedView ? 'Show Less' : 'Show More'
      }
    }
  }
</script>

<style lang="scss">
  .panel-size-btn {
    @include naked-btn;
    display: inline;
    padding-left: 0;
    color: #FFFFFF;
    font-size: rem(14);

    &:focus {
      outline: 0;
    }

    svg {
      transform: rotateZ(180deg);
      margin-left: rem(4);
      vertical-align: middle;
      fill: color(yellow);
    }

    &--expanded svg {
      transform: rotateZ(0deg);
    }
  }
</style>



// WEBPACK FOOTER //
// PanelSizeBtn.vue?4c0c6855